import { FetchModelResponse } from '@cian/http-api';

import { IGetNewbuildingPromoPinsForMapResponseSchema } from 'shared/common/repositories/search-offers-index/entities/get_newbuilding_promo_pins_for_map/GetNewbuildingPromoPinsForMapResponseSchema';
import { IErrorResponseSchema } from 'shared/common/repositories/search-offers-index/entities/schemas/ErrorResponseSchema';

export const mapGetNewbuildingPromoPinsForMapResponse = (
  response: IGetNewbuildingPromoPinsForMapResponseSchema,
): FetchModelResponse<200, 'json', IGetNewbuildingPromoPinsForMapResponseSchema> => {
  return {
    statusCode: 200,
    response,
  };
};

export const mapGetNewbuildingPromoPinsForMapResponseError = (
  response: IErrorResponseSchema,
): FetchModelResponse<400, 'json', IErrorResponseSchema> => {
  return {
    statusCode: 400,
    response: {
      errors: response.errors,
      message: response.message,
    },
  };
};
